import { Component, Input } from '@angular/core';
import { InfoLinks } from '@sondermind/core/enums/info-links.enum';

/**
 * This footer is used in public-facing applications like the
 * provider-landing-page and provider-directory.
 */
@Component({
  selector: 'public-footer',
  templateUrl: './public-footer.component.html',
  styleUrls: ['./public-footer.component.scss']
})
export class PublicFooterComponent {
  emergencyResources = InfoLinks.EMERGENCY_RESOURCES;

  @Input() therapyMatchFlowUrl: string = '';
  @Input() psychiatryMatchFlowUrl: string = '';
}
